import { SingleStateConfig } from './routineConfig';
import { RoutineState } from './routineState';

export interface StatusBaseConfig {
  statuses: string[];
  openEndedResponse: boolean;
  responseExceptions?: string[];
  responseMissingExceptions?: string[];
}

export interface StatusConfig extends SingleStateConfig, StatusBaseConfig {}

export interface StatusResponse {
  status: string;
  openEndedResponse: string;
}

export interface StatusState extends RoutineState, StatusResponse {}
